import { Component, ElementRef, Inject, Input } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, firstValueFrom, of, takeUntil } from 'rxjs';
import { ResidentsService } from './residents.service';
import { DataService } from '@app/core/services/data.service';
import { formatFormErrors } from '@app/shared/formly/form-config';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { SlideCommonService } from '../common/slide-common.service';
import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { FormlyModule } from '@ngx-formly/core';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { WINDOW, WINDOW_PROVIDERS } from '@app/shared/services/window/window.service';

@Component({
    selector: 'app-residents',
    templateUrl: './residents.component.html',
    providers: [
        ResidentsService,
        WINDOW_PROVIDERS
    ],
    imports: [
        CommonModule,
        ConnectSlideComponent,
        SpinnerComponent,
        FormlyModule,
        AsyncPipe,
        NgIf,
        NgFor
    ]
})
export class ResidentsComponent {
    @Input() slideNumber: string | undefined;
    @Input() finalSlide = false;
    currentSlide = 'residents';
    active = this.afs.getActive();
    showSubmit = false;
    showError = false;
    showFormErrors = false; //error summary
    errorMessage = "";
    errors: any = [];
    isDisabled = false;
    submitting = false;

    form: FormGroup = new FormGroup(
        {}
    );
    fields: BehaviorSubject<any> = new BehaviorSubject([]);
    model: any = this.afs.getResidentsModel();

    constructor(
        private afs: ApplicationFormService,
        private logger: LoggerService,
        private el: ElementRef,
        private residentsService: ResidentsService,
        private dataService: DataService,
        private applicationFormDataService: ApplicationFormDataService,
        private slideCommon: SlideCommonService,
        @Inject(WINDOW) private window: Window,
    ) { }

    private destroy$ = new Subject<void>();

    subscription = this.afs.subscribeResidentsModel((data: any) => {
        this.model = data;

        const observables: Observable<any>[] = [
            of(this.residentsService.fetchForm()),
            // of(this.afs.getFormState()),
        ]

        this.dataService.ready(observables).pipe(takeUntil(this.destroy$)).subscribe(
            {
                next: ([ form ]) => {

                    this.fields.next(form);

                    // set the default value before on load
                    if (this.model.additionalResidents && this.model.additionalResidents.length === 0) {
                        this.model.additionalResidents = [ null ]
                    }

                    this.showSubmit = true;
                },
                error: () => {
                    console.log('"ready" function failed');
                }
            }
        );
    });

    get formState() {
        return this.afs.formState;
    }

    onBack() {
        this.isDisabled = false;
        this.submitting = false;
        this.afs.goBack('residents');
        this.slideCommon.scroll(this.active.active)
    }

    onSubmit() {
        this.logger.info('residents submit clicked', this.model.applicationContactAddressId);
        this.form.markAllAsTouched();

        if (this.form.valid) {
            console.log("VALID");
            this.errors = [];
            this.showFormErrors = false;

            this.isDisabled = true;
            this.submitting = true;

            console.log(this.model);

            this.afs.setResidentsModel(this.model);

            if (!(this.model.additionalResidents && this.model.additionalResidents[ 0 ] === null)) {
                this.afs.addResidentIds();
            }

            firstValueFrom(this.applicationFormDataService.postAdditionalResidents(this.model)).then((response: any) => {
                console.log('additional residents post success ' + response.status);

                this.slideCommon.save(this.form, this.currentSlide, this.formState, this.active);

                this.isDisabled = false;
                this.submitting = false;
            }).catch((error) => {
                this.isDisabled = false;
                this.submitting = false;
                this.logger.error(error);
            });
        }
        else {
            console.log("INVALID", this.form.errors)
            const renderTime = 500;
            const revealTime = renderTime + 250;

            setTimeout(() => {
                this.errors = formatFormErrors(this.el, this.form);
                this.showFormErrors = true;
            }, renderTime);

            setTimeout(() => {
                this.scrollToId('residents-error-summary');
            }, revealTime);
        }
    }

    scrollToId(id: string) {
        this.slideCommon.scrollToId(id, this.el, this.window);
    }
}
